import { z } from "zod";
import { optionalTrimmedString, requiredString, trimmedString } from "./primitives";

export const assigneeTypeSchema = z.enum(["team", "role", "agent", "human"]);

export const assignEntitySchema = z.object({
  assigneeType: assigneeTypeSchema,
  assigneeId: trimmedString,
  rationale: optionalTrimmedString.optional(),
  isFallback: z.boolean().optional(),
});

export const overrideAssignmentSchema = assignEntitySchema.extend({
  rationale: requiredString("Override rationale"),
});

export type AssignEntityPayload = z.infer<typeof assignEntitySchema>;
export type OverrideAssignmentPayload = z.infer<typeof overrideAssignmentSchema>;
export type AssigneeType = z.infer<typeof assigneeTypeSchema>;
